// extracted by mini-css-extract-plugin
var _1 = "content-wrapper__qn_TT";
var _2 = "page__GFCkh";
var _3 = "page-content__Sv6bj";
export { _1 as "contentWrapper", _2 as "page", _3 as "pageContent" }
